module.exports = __webpack_public_path__ + "static/img/card3.97eab70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/card3.png
// module id = cTGm
// module chunks = 0